export enum AlertVariantEnum {
    ERROR = "error",
    INFO = "info",
    SUCCESS = "success",
    WARNING = "warning",
}

export enum DirectionEnum {
    LTR = "ltr",
    RTL = "rtl",
}

export enum JobStatusEnum {
    COMPLETED = "completed",
    FAILED = "failed",
    PENDING = "pending",
    PROCESSING = "processing",
}

export enum LanguageEnum {
    AR = "ar",
    EN = "en",
}

export enum LogoSizeEnum {
    LG = "lg",
    MD = "md",
    SM = "sm",
}
